.answer {
  border-top: 1.5px solid var(--ink);
}

.answer:first-of-type {
  border-top: 0;
}

.heading {
  font-size: inherit;
  font-weight: inherit;
}

.head {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 64px;
  padding: 14px 18px;
  border: 0;
  background: var(--surface);
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.open {
  border-bottom: 1.5px solid var(--ink);
  background: var(--accent-soft);
}

.number {
  flex: 0 0 auto;
  min-width: 26px;
  font-weight: 700;
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.item {
  font-size: 15px;
  line-height: 1.4;
}

.picked {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
}

.badge {
  padding: 1px 8px;
  border: 1.5px solid var(--private-ink);
  border-radius: 999px;
  background: var(--private);
  color: var(--private-ink);
  font-size: 12px;
}

.chevron {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: var(--ink-3);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}

.open .chevron {
  transform: rotate(180deg);
}

.panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px 18px 18px;
}

/* A closed panel stays in the page, out of sight, of the tab order and of
 * screen readers; its display would otherwise override the attribute. */
.panel[hidden] {
  display: none;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  padding: 2px 10px;
  border-radius: 6px;
  color: var(--ink-2);
  font-size: 15px;
}

.chosen {
  background: var(--accent-soft);
  color: var(--ink);
  font-weight: 700;
}

.dot {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  border: 2px solid var(--ink-3);
  border-radius: 999px;
}

.chosen .dot {
  border-color: var(--ink);
  background: var(--ink);
}

.theirs {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-2);
}
